import { bl_fi_einvoice_discrepancies_report_line_RowClass } from "../../dbschema/bl_fi_einvoice_discrepancies_report_line.model";
import { BaseContainerModel } from "../base-container.model";

export class EinvoiceDiscrepanciesReportLineContainerModel extends BaseContainerModel {
    bl_fi_einvoice_discrepancies_report_line: bl_fi_einvoice_discrepancies_report_line_RowClass = new bl_fi_einvoice_discrepancies_report_line_RowClass();
}